// note that these are currently put into the style section instead of being
// defined in classes to aid copy and paste to an external document e.g. word
export const intronColor = undefined
export const utrColor = 'rgb(200,240,240)'
export const proteinColor = 'rgb(220,160,220)'
export const cdsColor = 'rgb(220,220,180)'
export const updownstreamColor = 'rgba(250,200,200)'
export const genomeColor = 'rgb(200,280,200)'
